export default "__VITE_ASSET__CWH_g0Qe__"